module.exports = __webpack_public_path__ + "static/media/truck_recycling.ea2d6cf6.png";